import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import UserForm from "../../../components/user/UserForm";
import useUser from "../../../hooks/useUser";

export default function UserManagePage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const isCreate = id === "create";
    const { fetchOne } = useUser();
    const [loading, setLoading] = useState(!isCreate);
    const [user, setUser] = useState(null);

    useEffect(() => {
        if (isCreate) return;

        let active = true;
        setLoading(true);
        fetchOne(id)
            .unwrap()
            .then((result) => {
                if (active) setUser(result?.data?.response || null);
            })
            .catch(() => {
                if (active) setUser(null);
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => { active = false; };
    }, [id, isCreate, fetchOne]);

    return (
        <Box sx={{ width: "100%", minHeight: "100%" }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
                <Box>
                    <Typography variant="h5" fontWeight={600}>
                        {isCreate ? "Create User" : "Update User"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {isCreate ? "Add a user and configure account access." : "Update account details, role, and status."}
                    </Typography>
                </Box>
                <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/users/list")}>
                    Back to users
                </Button>
            </Stack>

            <Paper variant="outlined" sx={{ width: "100%", p: { xs: 1, md: 2 }, borderRadius: 1 }}>
                {loading ? (
                    <Box sx={{ display: "grid", placeItems: "center", minHeight: 240 }}>
                        <CircularProgress />
                    </Box>
                ) : !isCreate && !user ? (
                    <Typography color="error">Unable to load this user.</Typography>
                ) : (
                    <UserForm
                        mode={isCreate ? "create" : "edit"}
                        user={user}
                        showTitle={false}
                        onCancel={() => navigate("/users/list")}
                        onSuccess={() => navigate("/users/list")}
                    />
                )}
            </Paper>
        </Box>
    );
}